'use client';

import { $api } from '@shared/apis';

/**
 * GET /api/v1/branches/{branchId} — 리드폼 모달에서 사용하는 지점 상세 조회.
 * 사이드바의 지점명/뱃지 표시 + tabs 기반 상품 카드 노출을 위해 호출한다.
 */
export function useBranchDetail(branchId: number) {
  return $api.useQuery(
    'get',
    '/api/v1/branches/{branchId}',
    { params: { path: { branchId } } },
    { enabled: Number.isFinite(branchId) && branchId > 0 },
  );
}
